// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartkit-control-item__control {
  display: inline-flex;
  vertical-align: bottom;
  align-items: center;
  position: relative;
}
.chartkit-control-item__control_mobile {
  align-items: flex-start;
  flex-direction: column;
}
.chartkit-control-item__control_mobile .chartkit-control-item__title {
  font-family: var(--g-text-subheader-font-family);
  font-weight: var(--g-text-subheader-font-weight);
  font-size: var(--g-text-subheader-2-font-size);
  line-height: var(--g-text-subheader-2-line-height);
  margin-bottom: 5px;
}
.chartkit-control-item__control_mobile .chartkit-control-item__yc-select {
  border-radius: 10px;
}
.chartkit-control-item__control_without-label {
  flex-direction: row;
  align-items: center;
}
.chartkit-control-item__control_vertical {
  flex-direction: column;
  align-items: flex-start;
}
.chartkit-control-item__control_vertical .chartkit-control-item__title {
  margin-right: 0;
  margin-bottom: 8px;
}
.chartkit-control-item__title {
  margin-right: 8px;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  display: flex;
}
.chartkit-control-item__title_vertical {
  max-width: 100%;
}
.chartkit-control-item__title-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.chartkit-control-item__component, .chartkit-control-item__yc-select {
  flex-grow: 1;
  overflow: hidden;
}
.chartkit-control-item__component_vertical {
  width: 100%;
}
.chartkit-control-item__textarea .textarea__control {
  font-family: "Consolas", "Menlo", "Ubuntu Mono", monospace;
}
.chartkit-control-item__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 1;
}
.chartkit-control-item__overlay_move {
  cursor: move;
}
.chartkit-control-item__component_accent_info {
  --g-text-input-background-color: var(--g-color-base-info-light);
}
.chartkit-control-item__yc-select_accent_info {
  --yc-select-badge-color: var(--g-color-base-selection-hover);
  --yc-select-background-color: var(--g-color-base-info-light);
  --yc-select-background-color-hover: var(--g-color-base-info-light-hover);
}`, "",{"version":3,"sources":["webpack://./src/ui/libs/DatalensChartkit/components/Control/Items/Items.scss","webpack://./node_modules/@gravity-ui/uikit/styles/mixins.scss"],"names":[],"mappings":"AAOI;EACI,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AANR;AAQQ;EACI,uBAAA;EACA,sBAAA;AANZ;AAQY;ECqNR,gDAAA;EACA,gDAAA;EACA,8CAAA;EACA,kDAAA;EDtNY,kBAAA;AAHhB;AAMY;EACI,mBAAA;AAJhB;AAQQ;EACI,mBAAA;EACA,mBAAA;AANZ;AASQ;EACI,sBAAA;EACA,uBAAA;AAPZ;AASY;EACI,eAAA;EACA,kBAAA;AAPhB;AAYI;EACI,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AAVR;AAYQ;EACI,eAAA;AAVZ;AAcI;ECnDA,mBAAA;EACA,gBAAA;EACA,uBAH4B;AD2ChC;AAaI;EAEI,YAAA;EACA,gBAAA;AAZR;AAgBQ;EACI,WAAA;AAdZ;AAmBQ;EACI,0DAvEU;AAsDtB;AAqBI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;AAnBR;AAqBQ;EACI,YAAA;AAnBZ;AAwBQ;EACI,+DAAA;AAtBZ;AA0BQ;EACI,4DAAA;EACA,4DAAA;EACA,wEAAA;AAxBZ","sourcesContent":[".chartkit-control-item__control {\n  display: inline-flex;\n  vertical-align: bottom;\n  align-items: center;\n  position: relative;\n}\n.chartkit-control-item__control_mobile {\n  align-items: flex-start;\n  flex-direction: column;\n}\n.chartkit-control-item__control_mobile .chartkit-control-item__title {\n  font-family: var(--g-text-subheader-font-family);\n  font-weight: var(--g-text-subheader-font-weight);\n  font-size: var(--g-text-subheader-2-font-size);\n  line-height: var(--g-text-subheader-2-line-height);\n  margin-bottom: 5px;\n}\n.chartkit-control-item__control_mobile .chartkit-control-item__yc-select {\n  border-radius: 10px;\n}\n.chartkit-control-item__control_without-label {\n  flex-direction: row;\n  align-items: center;\n}\n.chartkit-control-item__control_vertical {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.chartkit-control-item__control_vertical .chartkit-control-item__title {\n  margin-right: 0;\n  margin-bottom: 8px;\n}\n.chartkit-control-item__title {\n  margin-right: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  white-space: nowrap;\n  display: flex;\n}\n.chartkit-control-item__title_vertical {\n  max-width: 100%;\n}\n.chartkit-control-item__title-text {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.chartkit-control-item__component, .chartkit-control-item__yc-select {\n  flex-grow: 1;\n  overflow: hidden;\n}\n.chartkit-control-item__component_vertical {\n  width: 100%;\n}\n.chartkit-control-item__textarea .textarea__control {\n  font-family: \"Consolas\", \"Menlo\", \"Ubuntu Mono\", monospace;\n}\n.chartkit-control-item__overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  z-index: 1;\n}\n.chartkit-control-item__overlay_move {\n  cursor: move;\n}\n.chartkit-control-item__component_accent_info {\n  --g-text-input-background-color: var(--g-color-base-info-light);\n}\n.chartkit-control-item__yc-select_accent_info {\n  --yc-select-badge-color: var(--g-color-base-selection-hover);\n  --yc-select-background-color: var(--g-color-base-info-light);\n  --yc-select-background-color-hover: var(--g-color-base-info-light-hover);\n}",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
